import { CenteredSpinner , Center } from '~/commonComponents';
import { PageContainer } from '~/commonComponents/PageContainer';
import { lazy, Suspense } from 'react';
import { useOfficeTnCConsent } from '~/hooks/useOfficeTnCConsent';

const PDFPreviewConsent = lazy(() =>
  import('~/commonComponents/PDFPreviewConsent/PDFPreviewConsent').then((mod) => ({
    default: mod.PDFPreviewConsent,
  })),
);

export const TermsAndConditions = () => {
  const { isAccepting, handleAccept, pdfUrl, isLoading } = useOfficeTnCConsent();

  return (
    <Suspense
      fallback={
        <PageContainer>
          <div
            className="floating_container"
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              marginInline: '20px',
            }}
          >
            <Center marginTop={40}>
              <CenteredSpinner />
            </Center>
          </div>
        </PageContainer>
      }
    >
      <PDFPreviewConsent
        pdfUrl={pdfUrl}
        isLoading={isLoading}
        isAccepting={isAccepting}
        onConsent={handleAccept}
      />
    </Suspense>
  );
};
